exports = module.exports = require(22);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require(24);
exports.Duplex = require(20);
exports.Transform = require(23);
exports.PassThrough = require(21);
